import { initialiseComponents } from "../../../core";
import Component from "../../component.abstract";
import { hw } from "../../helpers/paths";

interface NavElementProps {
    anchor: string;
    attribute: string;
    complete: boolean;
    link: string;
    paragraph: string;
    svg: string;
    title: string;
    url: string;
}

export default class NavElement extends Component {
    private container: HTMLElement;

    constructor (
        readonly props: NavElementProps,
        element: HTMLElement
    ) {  
        super(props, element);

        this.container = <HTMLElement> this.element.parentNode;
    }

    mounted(): void {
        this.injectTemplate()

        if (this.props) {
            this.display();
            this.bindClick();
        }

        initialiseComponents();
    }

    bindClick(): void {
        this.element.addEventListener("click", (event: MouseEvent) => {
            event.stopImmediatePropagation();
  
            if (this.element.classList.contains("selected")) {
              // You're already selected, stupid
              return;
            }
  
            PubSub.publish("nav-element.selected", this);
        }) 
    }

    select(): void {
        this.container.classList.add('navlist--row');
        const elts = document.querySelectorAll('[data-profile-nav-element]');
        elts.forEach(elt => {
            elt.classList.remove('selected');
        });
        this.element.classList.add('selected');
    }
    
    display(): void {
         const svgns = "http://www.w3.org/2000/svg";
        const elt = this.element;
        (<HTMLElement> elt.querySelector("p.title span")).innerText = this.props.title;
        (<HTMLElement> elt.querySelector("p.para")).innerText = this.props.paragraph;
        const svgNav = document.createElementNS(svgns, "svg");
        svgNav.setAttribute(
            "data-load-url",
            hw.getBaseRessourcesUrl() + "/img/svg/" + this.props.svg + ".svg"
        );
        elt.querySelector(".figure").append(svgNav);

        if(this.props.complete) {
            elt.querySelector(".search-field .complete").classList.remove('hide');
        } else {
            elt.querySelector(".search-field .incomplete").classList.remove('hide');
        }
    }
}